export const ROUTES = {
    ROOT: '/',
    DASHBOARD: '/dashboard',
    LOGIN: '/login',
    REDIRECT: '/redirect',
    LOGOUT: '/logout',
    FORGOT_PASSWORD: '/forgot-password',
    CONTENT: '/content',
    WATCH_PARTY: '/watch-party',
    ADD_WATCH_PARTY: '/add-watch-party',
    EDIT_WATCH_PARTY: '/edit-watch-party',
    WATCH_PARTY_USERS: '/watch-party-users',
    WATCH_PARTY_HOSTS: '/watch-party-hosts',
    UPLOAD_WATCH_PARTY: '/upload-watch-party',
    FORGOT_PASSWORD: '/forget-password',
    RESET_PASSWORD: '/admin/reset-password',
    USERS: '/users',
    CLONE_WATCH_PARTY:'/clone-watch-party'
}